import { getRefPageLocalStorage } from "shared/helpers/ref-page";
import {
  AdvanceButtonClickEventName,
  DistroButtonClickEventName,
  HomeButtonClickEventName,
  LoginButtonClickEventName,
  MenuButtonClickEventName,
  PricingButtonClickEventName,
  QuincyButtonClickEventName,
  QuizButtonClickEventName,
  SignUpButtonClickEventName,
} from "./button-click-event-name";
import { LoginErrorEventName } from "./error-event-name";
import { HomeDialogEventName } from "./dialog-event-name";

const platformContext = "S4A";
const screenViewedEventName = "ScreenViewed";
const clickButtonEventName = "ClickButton";
const dialogViewedEventName = "DialogViewed";

export const dataLayerEventAcesso = (user: any) => {
  if (user) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      email: user.login,
      userId: user.cognitoUsername,
      time:
        user.userTeam?.length > 0
          ? user.userTeam[0].team?.displayName
          : "Sem time associado",

      event: "acesso",
    });
  }
};

export const dataLayerEvent = (event: string, params: any) => {
  const ref = getRefPageLocalStorage();
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    ...params,
    ref,
  });
};

interface TagManagerEvent {
  screenName: string;
  businessContext: string;
  platformContext: string;
}

interface PageViewEvents {
  Home: {
    S4A_HOME_UNDIAGNOSED: TagManagerEvent;
    S4A_HOME_DIAGNOSED: TagManagerEvent;
  };
  Quiz: {
    S4A_QUIZ_GENERAL_DATA: TagManagerEvent;
    S4A_QUIZ_PLATFORMS_CONNECT: TagManagerEvent;
    S4A_QUIZ_ANALYSIS_LOADING: TagManagerEvent;
  };
  FreeAssessment: {
    SPOTIFY_SEARCH_NEW_ASSESSMENT: TagManagerEvent;
    SPOTIFY_SELECTION_NEW_ASSESSMENT: TagManagerEvent;
    SPOTIFY_LINK_NEW_ASSESSMENT: TagManagerEvent;
    INSTAGRAM_SEARCH_NEW_ASSESSMENT: TagManagerEvent;
    INSTAGRAM_LINK_NEW_ASSESSMENT: TagManagerEvent;
    YOUTUBE_SEARCH_NEW_ASSESSMENT: TagManagerEvent;
    YOUTUBE_SELECTION_NEW_ASSESSMENT: TagManagerEvent;
    YOUTUBE_LINK_NEW_ASSESSMENT: TagManagerEvent;
    GENRE_SELECTION_NEW_ASSESSMENT: TagManagerEvent;
    COUNTRY_SELECTION_NEW_ASSESSMENT: TagManagerEvent;
    TELEPHONE_NEW_ASSESSMENT: TagManagerEvent;
  };
  Login: {
    S4A_LOGIN: TagManagerEvent;
  };
  SignUp: {
    S4A_SIGN_UP: TagManagerEvent;
    S4A_SIGN_UP_VERIFICATION: TagManagerEvent;
  };
  Advance: {
    S4A_ADVANCE_INDEX: TagManagerEvent;
    S4A_RELEASES_SELECTION: TagManagerEvent;
    S4A_ADVANCE_PROPOSAL: TagManagerEvent;
    S4A_ADVANCE_FORM: TagManagerEvent;
    S4A_WAITING_SIGNATURE: TagManagerEvent;
    S4A_ADVANCE_CONFIRMATION: TagManagerEvent;
    S4A_SIGNATURE_CONFIRMED: TagManagerEvent;
    S4A_ADVANCE_WAITING_MERGE: TagManagerEvent;
  };
  Distro: {
    S4A_DISTRO_SIGN: TagManagerEvent;
    S4A_DISTRO_FORM: TagManagerEvent;
    S4A_DISTRO_SIGNATURE_CONFIRMATION: TagManagerEvent;
  };
  Hero: {
    S4A_HERO: TagManagerEvent;
    S4A_HERO_DETAILS: TagManagerEvent;
    S4A_HERO_SIGN_UP: TagManagerEvent;
    S4A_HERO_VERIFICATION: TagManagerEvent;
    S4A_HERO_GREETINGS: TagManagerEvent;
    S4A_HERO_PORTAL: TagManagerEvent;
    S4A_HERO_GOODBYE: TagManagerEvent;
  };
  Quincy: {
    QUINCY_HOME: TagManagerEvent;
  };
  Goals: {
    GOALS: TagManagerEvent;
  };
  Promotions: {
    SONGTOOLS_WHITELABEL: TagManagerEvent;
  };
  Tour: {
    ONBOARDING_STAGE_LEVEL: TagManagerEvent;
    ONBOARDING_GOALS: TagManagerEvent;
    ONBOARDING_FUNDS: TagManagerEvent;
    ONBOARDING_QUINCY: TagManagerEvent;
    ONBOARDING_WELCOME: TagManagerEvent;
    ONBOARDING_COPILOT: TagManagerEvent;
  };
  Touring: {
    BREAKING_SOUND_SIGNED: TagManagerEvent;
    BREAKING_SOUND_UNSIGNED: TagManagerEvent;
  };
  Pricing: {
    PRICING_PAGE: TagManagerEvent;
  };
}

export const tagManagerEvent: PageViewEvents = {
  Home: {
    S4A_HOME_UNDIAGNOSED: {
      screenName: "S4A_HOME_UNDIAGNOSED",
      businessContext: "HOME",
      platformContext,
    },
    S4A_HOME_DIAGNOSED: {
      screenName: "S4A_HOME_DIAGNOSED",
      businessContext: "HOME",
      platformContext,
    },
  },
  Quiz: {
    S4A_QUIZ_GENERAL_DATA: {
      screenName: "S4A_QUIZ_GENERAL_DATA",
      businessContext: "QUIZ",
      platformContext,
    },
    S4A_QUIZ_PLATFORMS_CONNECT: {
      screenName: "S4A_QUIZ_PLATFORMS_CONNECT",
      businessContext: "QUIZ",
      platformContext,
    },
    S4A_QUIZ_ANALYSIS_LOADING: {
      screenName: "S4A_QUIZ_ANALYSIS_LOADING",
      businessContext: "QUIZ",
      platformContext,
    },
  },
  FreeAssessment: {
    SPOTIFY_SEARCH_NEW_ASSESSMENT: {
      screenName: "SPOTIFY_SEARCH_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    SPOTIFY_SELECTION_NEW_ASSESSMENT: {
      screenName: "SPOTIFY_SELECTION_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    SPOTIFY_LINK_NEW_ASSESSMENT: {
      screenName: "SPOTIFY_LINK_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    INSTAGRAM_SEARCH_NEW_ASSESSMENT: {
      screenName: "INSTAGRAM_SEARCH_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    INSTAGRAM_LINK_NEW_ASSESSMENT: {
      screenName: "INSTAGRAM_LINK_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    YOUTUBE_SEARCH_NEW_ASSESSMENT: {
      screenName: "YOUTUBE_SEARCH_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    YOUTUBE_SELECTION_NEW_ASSESSMENT: {
      screenName: "YOUTUBE_SELECTION_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    YOUTUBE_LINK_NEW_ASSESSMENT: {
      screenName: "YOUTUBE_LINK_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    GENRE_SELECTION_NEW_ASSESSMENT: {
      screenName: "GENRE_SELECTION_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    COUNTRY_SELECTION_NEW_ASSESSMENT: {
      screenName: "COUNTRY_SELECTION_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
    TELEPHONE_NEW_ASSESSMENT: {
      screenName: "TELEPHONE_NEW_ASSESSMENT",
      businessContext: "QUIZ_V2",
      platformContext,
    },
  },
  Login: {
    S4A_LOGIN: {
      screenName: "S4A_LOGIN",
      businessContext: "LOGIN",
      platformContext,
    },
  },
  SignUp: {
    S4A_SIGN_UP: {
      screenName: "S4A_SIGN_UP",
      businessContext: "SIGN_UP",
      platformContext,
    },
    S4A_SIGN_UP_VERIFICATION: {
      screenName: "S4A_SIGN_UP_VERIFICATION",
      businessContext: "SIGN_UP",
      platformContext,
    },
  },
  Advance: {
    S4A_ADVANCE_INDEX: {
      screenName: "S4A_ADVANCE_INDEX",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_RELEASES_SELECTION: {
      screenName: "S4A_RELEASES_SELECTION",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_PROPOSAL: {
      screenName: "S4A_ADVANCE_PROPOSAL",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_FORM: {
      screenName: "S4A_ADVANCE_FORM",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_WAITING_SIGNATURE: {
      screenName: "S4A_WAITING_SIGNATURE",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_CONFIRMATION: {
      screenName: "S4A_ADVANCE_CONFIRMATION",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_SIGNATURE_CONFIRMED: {
      screenName: "S4A_SIGNATURE_CONFIRMED",
      businessContext: "ADVANCE",
      platformContext,
    },
    S4A_ADVANCE_WAITING_MERGE: {
      screenName: "S4A_ADVANCE_WAITING_MERGE",
      businessContext: "ADVANCE",
      platformContext,
    },
  },
  Distro: {
    S4A_DISTRO_SIGN: {
      screenName: "S4A_DISTRO_SIGN",
      businessContext: "DISTRO",
      platformContext,
    },
    S4A_DISTRO_FORM: {
      screenName: "S4A_DISTRO_FORM",
      businessContext: "DISTRO",
      platformContext,
    },
    S4A_DISTRO_SIGNATURE_CONFIRMATION: {
      screenName: "S4A_DISTRO_SIGNATURE_CONFIRMATION",
      businessContext: "DISTRO",
      platformContext,
    },
  },
  Hero: {
    S4A_HERO: {
      screenName: "SH_ENTRY",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_DETAILS: {
      screenName: "SH_DETAILS",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_SIGN_UP: {
      screenName: "SH_SIGN_UP",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_VERIFICATION: {
      screenName: "SH_VERIFICATION",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_GREETINGS: {
      screenName: "SH_GREETINGS",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_PORTAL: {
      screenName: "SH_PORTAL",
      businessContext: "STRM_HERO",
      platformContext,
    },
    S4A_HERO_GOODBYE: {
      screenName: "SH_GOODBYE",
      businessContext: "STRM_HERO",
      platformContext,
    },
  },
  Quincy: {
    QUINCY_HOME: {
      screenName: "QUINCY_HOME",
      businessContext: "AI_ASSISTANTS",
      platformContext,
    },
  },
  Goals: {
    GOALS: {
      screenName: "GOALS",
      businessContext: "GOALS",
      platformContext,
    },
  },
  Promotions: {
    SONGTOOLS_WHITELABEL: {
      screenName: "SONGTOOLS_WHITELABEL",
      businessContext: "PROMOTIONS",
      platformContext,
    },
  },
  Tour: {
    ONBOARDING_STAGE_LEVEL: {
      screenName: "ONBOARDING_STAGE_LEVEL",
      businessContext: "ONBOARDING",
      platformContext,
    },
    ONBOARDING_GOALS: {
      screenName: "ONBOARDING_GOALS",
      businessContext: "ONBOARDING",
      platformContext,
    },
    ONBOARDING_FUNDS: {
      screenName: "ONBOARDING_FUNDS",
      businessContext: "ONBOARDING",
      platformContext,
    },
    ONBOARDING_QUINCY: {
      screenName: "ONBOARDING_QUINCY",
      businessContext: "ONBOARDING",
      platformContext,
    },
    ONBOARDING_WELCOME: {
      screenName: "ONBOARDING_WELCOME",
      businessContext: "ONBOARDING",
      platformContext,
    },
    ONBOARDING_COPILOT: {
      screenName: "ONBOARDING_COPILOT",
      businessContext: "ONBOARDING",
      platformContext,
    },
  },
  Touring: {
    BREAKING_SOUND_UNSIGNED: {
      screenName: "BREAKING_SOUND_UNSIGNED",
      businessContext: "TOURING",
      platformContext,
    },
    BREAKING_SOUND_SIGNED: {
      screenName: "BREAKING_SOUND_SIGNED",
      businessContext: "TOURING",
      platformContext,
    },
  },
  Pricing: {
    PRICING_PAGE: {
      screenName: "PRICING_PAGE",
      businessContext: "PRICING",
      platformContext,
    },
  },
};

export const dataLayerViewedEvent = (event: any) => {
  dataLayerEvent(screenViewedEventName, { ...event });
};

export const dataLayerClickedEvent = (
  buttonName:
    | HomeButtonClickEventName
    | LoginButtonClickEventName
    | QuizButtonClickEventName
    | SignUpButtonClickEventName
    | AdvanceButtonClickEventName
    | DistroButtonClickEventName
    | QuincyButtonClickEventName
    | MenuButtonClickEventName
    | PricingButtonClickEventName,
  event: any
) => {
  dataLayerEvent(clickButtonEventName, { buttonName, ...event });
};

export const dataLayerErrorEvent = (
  errorName: LoginErrorEventName,
  event: any
) => {
  dataLayerEvent("ErrorDialog", { errorName, ...event });
};

export const dataLayerDialogViewedEvent = (
  dialogName: HomeDialogEventName,
  event: any
) => {
  dataLayerEvent(dialogViewedEventName, { dialogName, ...event });
};
